export default {
  'dashboardandmonitor.monitor.trading-activity': 'Real-Time Trading Activity',
  'dashboardandmonitor.monitor.total-transactions': 'Total transactions today',
  'dashboardandmonitor.monitor.sales-target': 'Sales target completion rate',
  'dashboardandmonitor.monitor.remaining-time': 'Remaining time of activity',
  'dashboardandmonitor.monitor.total-transactions-per-second': 'Total transactions per second',
  'dashboardandmonitor.monitor.activity-forecast': 'Activity forecast',
  'dashboardandmonitor.monitor.efficiency': 'Efficiency',
  'dashboardandmonitor.monitor.ratio': 'Ratio',
  'dashboardandmonitor.monitor.proportion-per-category': 'Proportion Per Category',
  'dashboardandmonitor.monitor.fast-food': 'Fast food',
  'dashboardandmonitor.monitor.western-food': 'Western food',
  'dashboardandmonitor.monitor.hot-pot': 'Hot pot',
  'dashboardandmonitor.monitor.waiting-for-implementation': 'Waiting for implementation',
  'dashboardandmonitor.monitor.popular-searches': 'Popular Searches',
  'dashboardandmonitor.monitor.resource-surplus': 'Resource Surplus',
  'dashboardandmonitor.monitor.fund-surplus': 'Fund Surplus',
};
